import { useContext } from 'react';
import GlobalContext from '../../GlobalContext'
export default () => {
    return useContext(GlobalContext).session.state;
};